<template>
    <div class="moodboard">
        <div class="moodboard__upload">
            <label class="button button--primary hint--item upload--xs" for="fileElem">{{ $t('uploadImage') }}</label>
            <div :class="isHighlighted" class="upload__dropzone"
                 @drop.prevent="addImage"
                 @dragover.prevent="setHighlight(true)"
                 @dragenter.prevent="setHighlight(true)"
                 @dragleave.prevent="setHighlight(false)"
            >
                <global-responsive-image v-if="!image" ref="sampleImage" @load="analyzeImage" class="moodboard__image img-fluid" :responsive-image="sampleImage" />
                <img v-else ref="userImage" @load="analyzeImage" class="moodboard__image img-fluid" :src="image"/>
                <div class="upload__hint">
                    <div class="upload__hint--wrapper">
                        <transition name="transition-moodboard--default" mode="out-in">
                            <div key="transition-wrapper-1" class="transition-wrapper" v-if="!showProcessing">
                                <span class="hint--item hint--drop"><img alt="drop image here" src="../assets/icon-download.svg">{{ $t('dropHere') }}</span>
                                <span class="hint--item">{{ $t('or') }}</span>
                                <input type="file" id="fileElem" accept="image/*" @change="addImage">
                                <label class="button button--primary hint--item" for="fileElem">{{ $t('uploadImage') }}</label>
                            </div>
                            <div key="transition-wrapper-2" class="transition-wrapper" v-if="showProcessing" @after-enter="showProcessingContent = true">
                                    <div key="analyzing" class="transition-wrapper" v-if="analyzing">
                                        <span class="hint--item"><img alt="loading" class="animation--spinner" src="../assets/icon-spinner.svg"></span>
                                        <span class="hint--item">{{ $t('analyzing') }}</span>
                                    </div>
                                    <div key="requestRunning" class="transition-wrapper" v-if="requestRunning">
                                        <span class="hint--item"><img alt="loading" class="animation--spinner" src="../assets/icon-spinner.svg"></span>
                                        <span class="hint--item">{{ $t('matching') }}</span>
                                    </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="dropzone__border dropzone--inner-border"></div>
                <div class="dropzone__border dropzone--outer-border"></div>
            </div>
        </div>
        <div class="moodboard__devider">
            <img src="../assets/icon-arrow--down.svg" alt="arrow down">
        </div>
        <moodboard-result :decors="result"/>
    </div>
</template>

<script>
import MoodboardResult from "../components/moodboard-result";
import ColorThief from "colorthief";
import GlobalResponsiveImage
    from "@global/global-elements/global-responsive-image/global-responsive-image";
import {track_abstract, tracking_events} from '@utilities/track-abstract/track-abstract';

export default {
    name: "upload-view",
    components: {GlobalResponsiveImage, MoodboardResult },
    data: function () {
        return {
            image: null,
            highlight: false,
            palette: null,
            analyzing: false,
            colorThief: null,
            result: null,
            requestRunning: false,
            showProcessingContent: false
        }
    },
    computed: {
        showProcessing() {
            return !(!this.analyzing && !this.requestRunning)
        },
        isHighlighted() {
            return this.highlight ? 'highlight': ''
        },
        sampleImage() {
            return window.moodboardResponsiveImages.sampleImage1
        }
    },
    methods: {
        addImage(e) {
            let file;
            if (e.type === 'drop') {
                file = [...e.dataTransfer.files][0]
            }
            if (e.type === 'change') {
                file = [...e.target.files][0]
            }
            if(file && /image\//.test(file.type)) {
                this.highlight = false;
                const reader = new FileReader();
                reader.onload = this.fileReaderLoaded
                reader.readAsDataURL(file)
            }

            track_abstract.trigger_event(tracking_events.MoodboardUpload, null);

            this.analyzing = true;
        },
        fileReaderLoaded(e) {
            this.image = e.target.result;
        },
        setHighlight(isHighlighted) {
            this.highlight = isHighlighted
        },
        analyzeImage(e) {
			this.result = null;
            this.analyzing = true;
            const image = e.currentTarget;
            window.setTimeout(async () => {
                if (this.colorThief) {
                    const palette = await this.colorThief.getPalette(image, 6, 1)
                    this.analyzing = false
                    this.result = await this.getDecors(palette);
                } else {
                    this.analyzing = false;
                }

            },10);
        },
        async getDecors(colorPalette) {
            const payload = new FormData();
            payload.append('tx_epim_moodboard[json]', JSON.stringify(colorPalette));

            try {
                this.requestRunning = true;
                const response = await this.$http.post(window.MOODBOARD_API, payload);
                const json = await response.json();
                this.requestRunning = false;
                return json
            } catch (e) {
                console.error('API call failed', e);
                return null;
            }
        }
    },
    mounted() {
        this.colorThief = new ColorThief();
    }
}
</script>

<style lang="scss">
@import "../base";
@import "../app/animation";

.moodboard {
    .moodboard__upload {
        .upload--xs {
            width: 100%;
            margin-bottom: 12px;

            @include media-breakpoint-up('md') {
                display: none;
            }
        }

        .upload__dropzone {
            position: relative;
            width: 100%;
            background-color: $pfl-color__gray-050;

            @include media-breakpoint-only('xl') {
                height: 731px;
            }

            @include media-breakpoint-only('lg') {
                height: 546px;
            }

            @include media-breakpoint-only('md') {
                height: 411px;
            }

            @include media-breakpoint-only('sm') {
                height: 169px;
            }

            @include media-breakpoint-only('xs') {
                height: 169px;
            }

            .moodboard__image:not(.global-responsive-image) {
                height: 100%;
                width: 100%;
                object-fit: contain;
            }

            .moodboard__image.global-responsive-image {
                height: 100%;
                width: 100%;

                .vue-image {
                    height: 100%;
                }

                img {
                    margin-top: 0;
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                }
            }

            .upload__hint {
                position: absolute;
                bottom: 34px;
                margin-left: 34px;
                margin-right: 34px;
                width: calc(100% - 2 * 34px);
                height: 82px;
                background-color: rgba($pfl-color__gray-000, 0.8);
                display: flex;
                flex-flow: row nowrap;
                justify-content: center;
                align-items: center;

                .transition-wrapper {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: center;
                    align-items: center;
                }

                @include media-breakpoint-down('sm') {
                    display: none;
                }

                .upload__hint--wrapper {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                }

                .hint--drop {
                    font-weight: $pfl-font__bold;
                    display: flex;
                    align-items: center;
                }

                .hint--item {
                    &:not(:last-child) {
                        margin-right: 24px;
                    }
                }
            }

            #fileElem {
                position: fixed;
                top: -1000px;
            }

            .dropzone__border {
                top: 0;
                position: absolute;
                width: 100%;
                height: 100%;
                pointer-events: none
            }

            &.highlight {
                .dropzone--outer-border {
                    border: 2px dashed black;
                }

                .dropzone--inner-border {
                    border: 21px solid white;
                }
            }
        }

        .animation--spinner {
            @extend %animation--spinner;
        }
    }

    .moodboard__devider {
        display: flex;
        justify-content: center;
        margin-top: 6px;
        border-top: 1px solid $pfl-color__gray-070;
    }
}
</style>
